import React from "react";
import styled from "styled-components";
import { SectionEyebrow, SectionTitle, SectionDescription } from "./common/Section";
import {
  FaSpotify,
  FaApple,
  FaTiktok,
  FaInstagram,
  FaYoutube,
  FaAmazon,
} from "react-icons/fa";

const Section = styled.section`
  padding: clamp(4rem, 6vw, 5.5rem) 8vw;
  border-top: 1px solid var(--ink-06);

  @media (max-width: 480px) {
    padding-left: 5vw;
    padding-right: 5vw;
  }
`;

const Header = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 0.9fr) minmax(0, 1.1fr);
  gap: 24px;
  align-items: end;
  margin-bottom: 32px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

const PartnerList = styled.div`
  display: grid;
  border-top: 1px solid var(--ink-10);
`;

const PartnerRow = styled.div`
  display: grid;
  grid-template-columns: 60px minmax(0, 0.6fr) minmax(0, 1.4fr);
  gap: 20px;
  padding: 20px 0;
  border-bottom: 1px solid var(--ink-06);
  align-items: center;

  @media (max-width: 768px) {
    grid-template-columns: 48px 1fr;
    gap: 14px;
  }
`;

const PartnerIcon = styled.div`
  font-size: 22px;
  color: var(--accent-3);
  display: flex;
  align-items: center;
  justify-content: center;
`;

const PartnerName = styled.span`
  font-size: 14px;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--ink);
`;

const PartnerNote = styled.span`
  color: var(--muted);
  font-size: 13px;
  line-height: 1.6;

  @media (max-width: 768px) {
    display: none;
  }
`;

const partners = [
  {
    icon: <FaSpotify />,
    name: "Spotify",
    note: "Playlist placements, editorial features, and streaming optimization.",
  },
  {
    icon: <FaApple />,
    name: "Apple Music",
    note: "Catalog distribution, spatial audio releases, and editorial positioning.",
  },
  {
    icon: <FaTiktok />,
    name: "TikTok",
    note: "Sound-first campaigns, viral reach, and creator-facing music strategy.",
  },
  {
    icon: <FaInstagram />,
    name: "Instagram",
    note: "Reels integration, branded audio, and visual-first release rollouts.",
  },
  {
    icon: <FaAmazon />,
    name: "Amazon Music",
    note: "HD distribution, voice-first discovery, and cross-platform catalog reach.",
  },
  {
    icon: <FaYoutube />,
    name: "YouTube",
    note: "Official releases, content ID management, and long-form visual strategy.",
  },
];

const PartnerSectionComponent = () => {
  return (
    <Section>
      <Header>
        <div>
          <SectionEyebrow>Platform reach</SectionEyebrow>
          <SectionTitle>Where the catalog lives.</SectionTitle>
        </div>
        <SectionDescription>
          RMS releases are distributed, promoted, and editorially supported across
          the world's major streaming and social platforms.
        </SectionDescription>
      </Header>
      <PartnerList>
        {partners.map((p) => (
          <PartnerRow key={p.name}>
            <PartnerIcon>{p.icon}</PartnerIcon>
            <PartnerName>{p.name}</PartnerName>
            <PartnerNote>{p.note}</PartnerNote>
          </PartnerRow>
        ))}
      </PartnerList>
    </Section>
  );
};

export default PartnerSectionComponent;
